import { render, staticRenderFns } from "./DocumentFormPage.vue?vue&type=template&id=8b809070&scoped=true"
import script from "./DocumentFormPage.vue?vue&type=script&lang=js"
export * from "./DocumentFormPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b809070",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b809070')) {
      api.createRecord('8b809070', component.options)
    } else {
      api.reload('8b809070', component.options)
    }
    module.hot.accept("./DocumentFormPage.vue?vue&type=template&id=8b809070&scoped=true", function () {
      api.rerender('8b809070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Documents/Conferences/DocumentFormPage.vue"
export default component.exports